export function isWindowPropertyAvailable(property: keyof Window) {
  return typeof window !== 'undefined' && !!window[property];
}
